/* Pretti Mall: Taiwan ID cart attribute field (see snippets/tw-id-field.liquid) */
(function () {
  if (window.customElements.get('tw-id-field')) return;
  var KEY = '台灣身分證字號';
  var RE = /^[A-Z][1289]\d{8}$/;
  var saveTimer = null;
  var lastSaved = null;

  function normalize(v) {
    return (v || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 10);
  }
  function isValid(v) {
    return v === '' || RE.test(v);
  }
  function save(v) {
    if (v === lastSaved) return Promise.resolve();
    var attrs = {};
    attrs[KEY] = v;
    return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) { if (r.ok) lastSaved = v; }).catch(function () {});
  }
  function allFields() {
    return Array.prototype.slice.call(document.querySelectorAll('tw-id-field'));
  }
  function setState(field, showError) {
    var input = field.querySelector('input');
    var err = field.querySelector('.tw-id-field__error');
    var ok = isValid(input.value);
    input.setAttribute('aria-invalid', ok ? 'false' : 'true');
    field.classList.toggle('tw-id-field--invalid', !ok && showError);
    if (err) err.hidden = ok || !showError;
    document.documentElement.classList.toggle('tw-id-invalid', !allFields().every(function (f) {
      return isValid(f.querySelector('input').value);
    }));
    return ok;
  }

  class TwIdField extends HTMLElement {
    connectedCallback() {
      var field = this;
      var input = this.querySelector('input');
      if (!input || input.dataset.twidBound) return;
      input.dataset.twidBound = '1';
      input.value = normalize(input.value);
      if (lastSaved === null) lastSaved = input.value;
      setState(field, input.value !== '');
      input.addEventListener('input', function () {
        var pos = input.selectionStart;
        var n = normalize(input.value);
        if (n !== input.value) { input.value = n; try { input.setSelectionRange(pos, pos); } catch (e) {} }
        var ok = setState(field, input.value.length >= 10 || field.classList.contains('tw-id-field--invalid'));
        clearTimeout(saveTimer);
        if (ok) saveTimer = setTimeout(function () { save(input.value); }, 400);
      });
      input.addEventListener('blur', function () {
        if (setState(field, true)) { clearTimeout(saveTimer); save(input.value); }
      });
    }
  }
  customElements.define('tw-id-field', TwIdField);

  // Block checkout while the ID is filled in but invalid; make sure the value is saved first.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
    if (!btn) return;
    var bad = allFields().filter(function (f) { return !setState(f, true); });
    if (bad.length) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var inp = bad[0].querySelector('input');
      inp.focus();
      inp.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }, true);
  document.addEventListener('submit', function (e) {
    if (!e.target || e.target.id !== 'cart-form') return;
    var bad = allFields().filter(function (f) { return !setState(f, true); });
    if (bad.length) { e.preventDefault(); e.stopImmediatePropagation(); bad[0].querySelector('input').focus(); }
  }, true);
})();
